import * as React from "react";

import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

export type InputProps = React.ComponentProps<"input"> & {
    startIcon?: LucideIcon;
    errored?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, startIcon, errored, type, ...props }, ref) => {
        const StartIcon = startIcon;

        return (
            <div className="relative w-full">
                {StartIcon && (
                    <div className="absolute top-1/2 left-4 -translate-y-1/2 transform">
                        <StartIcon size={16} className="text-muted-foreground" />
                    </div>
                )}
                <input
                    type={type}
                    className={cn(
                        "border-input file:text-foreground placeholder:text-muted-foreground focus-visible:ring-ring flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                        startIcon ? "pl-10" : "",
                        errored && "border-red-500 focus-visible:ring-red-500",
                        className,
                    )}
                    ref={ref}
                    {...props}
                />
            </div>
        );
    },
);
Input.displayName = "Input";

export { Input };
